import { useAct } from 'FlowBuilder/store'
import './styles/TemplatesForm.scoped.scss'
import AsyncSelect from 'Shared/components/AsyncSelect'
import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'
import { useLanguagesData } from 'FlowBuilder/hooks/useLanguageFlow'
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate'

export default function TemplatesForm({ actionId }) {
  const act = useAct()
  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const actionTemplates = useSel(s => _.values(s.actionTemplates.entities).filter(at => at.actionId === actionId))
  const config = action.config || { decisionMakerSetId: '' }
  const [sourceMode, setSourceMode] = useState(false)
  const mergeTags = useSel(s => s.builder.mergeTags)
  const { editableLanguagesData } = useLanguagesData()

  const {
    translated: { footerContent },
    fallback: { footerContent: footerContentFallback},
    textContentUpdater,
    flag
  } = useActionTranslate({ actionId })

  function createNewTemplate() {
    act.local.setModal({ kind: 'editTemplate', actionTemplateId: null, actionId })
  }

  function editTemplate(actionTemplateId) {
    act.local.setModal({ kind: 'editTemplate', actionTemplateId })
  }

  function removeTemplate(actionTemplateId) {
    act.actionTemplates.upsert(actionTemplateId, { active: false })
  }

  function restoreTemplate(actionTemplateId) {
    act.actionTemplates.upsert(actionTemplateId, { active: true })
  }

  function update(data) {
    act.actions.upsert(actionId, { config: { ...config, ...data } })
  }

  return <div>
    <h2 className='no-margin-top no-margin-bottom'>Pre-written emails</h2>
    <p className="smaller dark-grey bold margin-bottom no-margin-top">If multiple templates are provided, a random one will be selected for each email sent.</p>
    {actionTemplates.length > 0 && <div className='margin-bottom'>
      {actionTemplates.map(at => (
        <div key={at.id} className='margin-bottom row'>
          <div className={`column remaining ${at.active ? '' : 'inactive'}`}>
            {at.name}
          </div>
          <div className="actions flex-center gap-12">
            {at.language && editableLanguagesData && editableLanguagesData[at.language] && <div>{editableLanguagesData[at.language].flag}</div>}
            {at.active && <div onClick={() => editTemplate(at.id)}><SvgIconsEdit /></div>}
            {at.active && <div onClick={() => removeTemplate(at.id)}><SvgIconsDelete /></div>}
            {!at.active && <div onClick={() => restoreTemplate(at.id)}><SvgIconsUndo /></div>}
          </div>
        </div>
      ))}
    </div>}
    <button className='button tertiary' onClick={createNewTemplate}>Add Template</button>

    <div className='field flex margin-top double'>
      <label className="bold">Include footer</label>
      <input
        className="margin-left"
        type="checkbox"
        checked={config.includeFooter}
        onChange={e => update({ includeFooter: e.target.checked })}
      />
    </div>
    {config.includeFooter && <div className='field margin-top'>
      <label className="bold margin-bottom half">Footer content {flag}</label>
      <InlineCkEditor
        value={footerContent ?? ''}
        sourceMode={sourceMode}
        setSourceMode={setSourceMode}
        onUpdate={value => textContentUpdater('footerContent', value)}
        placeholder={footerContentFallback ?? ''}
        mergeTags={mergeTags}
        disabled={!config.includeFooter}
      />
    </div>}

    <div className='input-group sender'>
      <h2>Sender</h2>
      <div className='field'>
        <label className="bold margin-bottom">Select an email address that emails will originate from</label>
        <p>Your supporters will be included in all emails sent, and recipients will reply to your supporters directly.</p>
        <AsyncSelect
          entity="email_sender"
          value={config.emailSenderId}
          onChange={value => update({ emailSenderId: value })}
          loadStaticList
        />
      </div>
    </div>
  </div>
}
